import axios, { AxiosInstance } from 'axios';
import config from '@app/config';
import { readToken } from './localStorage.service';
import { createBrowserHistory } from 'history'; // Import browser history for navigation

// Create browser history
const history = createBrowserHistory();

// Create an Axios instance
const instance: AxiosInstance = axios.create({
  baseURL: config.API1Url, // Replace with your API base URL
  timeout: 40000, // Set the timeout for requests (optional)
  headers: {
    'Content-Type': 'application/json',
    Authorization: 'Bearer '+ readToken(),
  },
});

// Add a request interceptor to always attach the latest token
instance.interceptors.request.use((reqConfig) => {
  const token = readToken();
  if (token) {
    reqConfig.headers = {
      ...reqConfig.headers,
      Authorization: `Bearer ${token}`,
    };
  }
  return reqConfig;
});

// Add a response interceptor to handle 401 Unauthorized responses
instance.interceptors.response.use(
  (response) => {
    // If the response is successful, simply return it
    return response;
  },
  (error) => {
    // Check if the response status is 401 (Unauthorized)
    if (error.response && error.response.status === 401) {
      console.warn('Unauthorized! Redirecting to /logout...');
      // Navigate to /logout
      history.push('/logout');
      window.location.reload(); // Optional: Force a reload to clear user state
    }
    return Promise.reject(error); // Reject the promise with the error
  }
);

export default instance;
